<template>
    <div class="lp_sidelink" :style="{'height': component_data.params.offset}" >
        <a :href="component_data.params.link" class="lp_sidelink-badge" >
            <img :src="component_data.params.img" alt="">
            <span v-html="component_data.params.text"></span>
        </a>
    </div>
</template>

<script>
export default {
    props: ['component_data']
}
</script>

<style lang="scss">
    .lp_sidelink {
        width: 0;
        position: absolute;
        overflow: visible;
        right: 0;
        margin-top: 240px;
    }
    .lp_sidelink-badge {
        width: 240px;
        background: linear-gradient(to right, #E41429, #AE0B11);
        transform: translateX(-100%);
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        padding: 3em 1.6em 1.4em;
        color: white;
        position: sticky;
        top: 45vh;
        z-index: 20;
        text-transform: uppercase;
        font-size: .8em;
        letter-spacing: .1em;
        display: block;

        @media screen and (max-width: 992px) {
          width: auto;
        }
    }
    .lp_sidelink-badge img {
        position: absolute;
        top: 0;
        transform: translateY(-80%);
        width: 50%;
    }
    .lp_sidelink-badge:hover {
        text-decoration: none;
        color: white
    }
    @media(max-width: 1300px){
        .lp_sidelink-badge {
            position: absolute;
            top: 27vw;
        }
        .lp_sidelink-badge img {
            position: absolute;
            top: 0;
            transform: translateY(-80%);
        }
    }
    @media(max-width: 992px){
        .lp_sidelink-badge {
          top: 57vw;
        }
    }

</style>
